import { API_ROUTES } from "../../api/ApiRoutes";
import { AppStrings } from "../../utils/constants/AppStrings";
import type { PaymentTransactionsExportRequest } from "../../types/paymentTransactions";
import { useAsyncExport } from "../useAsyncExport";
import type { AsyncExportState } from "../useAsyncExport.types";

export const PAYMENT_TRANSACTIONS_EXPORT_START_KEY =
  "PAYMENT_TRANSACTIONS_EXPORT_START";
export const PAYMENT_TRANSACTIONS_EXPORT_STATUS_KEY =
  "PAYMENT_TRANSACTIONS_EXPORT_STATUS";

const buildStatusPath = (exportId: string): string =>
  API_ROUTES.PAYMENT_TRANSACTIONS_EXPORT_STATUS.replace(
    "{export_id}",
    exportId,
  );

export function usePaymentTransactionsExport(): AsyncExportState<PaymentTransactionsExportRequest> {
  return useAsyncExport<PaymentTransactionsExportRequest>({
    startPath: API_ROUTES.PAYMENT_TRANSACTIONS_EXPORT_START,
    statusPath: buildStatusPath,
    strings: {
      startError: AppStrings.PAYMENTS_TRANSACTIONS_EXPORT_START_ERROR,
      failedDefault:
        AppStrings.PAYMENTS_TRANSACTIONS_EXPORT_FAILED_DEFAULT,
      timeout: AppStrings.PAYMENTS_TRANSACTIONS_EXPORT_TIMEOUT,
    },
    queryKeys: {
      start: PAYMENT_TRANSACTIONS_EXPORT_START_KEY,
      status: PAYMENT_TRANSACTIONS_EXPORT_STATUS_KEY,
    },
  });
}

export default usePaymentTransactionsExport;
